import ky from 'ky';
import { ERROR_CODE } from '@/lib/config/errorCode';

export async function requestSolPrice(): Promise<number | undefined> {
  try {
    const response = await ky
      .get(
        'https://api.coingecko.com/api/v3/simple/price?ids=solana&vs_currencies=usd',
        {
          retry: 0,
        },
      )
      .json<{
        solana: { usd: number };
      }>();
    return response.solana.usd;
  } catch (error) {
    console.error('Error fetching Solana price:', error);
    // throw new Error(ERROR_CODE.NETWORK_ERROR);
  }
}
